import { render, staticRenderFns } from "./SizzledeckBlocks.vue?vue&type=template&id=67f97a1f&"
import script from "./SizzledeckBlocks.vue?vue&type=script&lang=js&"
export * from "./SizzledeckBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports